<template>
  <base-dialog-button
    :isOpen="dialogOpen"
    @closeDialog="toggleDialog"
    :size="size"
    :ariaLabel="title"
    class="w-full">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{ title }}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon
            name="cross"
            size="xs"
            iconSize="sm"
            mode="secondary"
          />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="loader" v-if="isGeneralLoading">
        <loading
          :opacity="0"
          :active.sync="isGeneralLoading"
          color="var(--primary-DEFAULT)"
        ></loading>
      </div>
      <div class="h-fix-pdf xl:inline-block w-full hideHScroll">
        <div v-if="downloadPDF || uploadFirmaDelegada" class="h-full flex items-center justify-center">
          <el-form :model="form" ref="ruleForm" :rules="uploadFirmaDelegada ? uploadRules :rules" class="items-center justify-center">
            <!-- <h2 class="px-2 w-full mb-2 lg:mb-0 font-bold">{{ $t("companies.configuration.firma_delegada.subir_pdf_firma")}}</h2> -->
            <el-form-item prop="file" ref="uploadpfxref">
              <div>
                <Upload
                  ref="upload"
                  accept=".pdf"
                  id="pdfselectorupload"
                  class=""
                  drag
                  action="#"
                  :show-file-list="false"
                  :multiple="false"
                  :auto-upload="false"
                  :on-remove="handleRemove"
                  :on-change="handleChange"
                >
                  <i class="el-icon-upload"></i>
                  <p v-if="file.name" class="el-upload__text">
                    <em>{{ file.name }}</em>
                  </p>
                  <div
                    v-else
                    class="el-upload__text"
                    v-safe-html="$tc('app.upload_default_no_file_text', 1)"
                  ></div>
                </Upload>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <PDFViewerApp
          v-show="showPDF && (!downloadPDF && !uploadFirmaDelegada)"
          class="h-full w-full"
          :search="actualFilterContent"
          @pdfViewerOpenHandler="pdfViewerOpenHandler"
          :pdf="url"
        />
      </div>
    </template>
    <template slot="footer">
      <div class="w-full">
        <div class="flex justify-around">
          <base-button-responsive 
            :loading="isGeneralLoading"
            v-if="!downloadPDF && !uploadFirmaDelegada"
            @click.prevent.stop="descargarArchivo"
            icon="download"
            :text="$t('companies.configuration.firma_delegada.descargar_delegacion_firma')" 
          />
          <base-button-responsive 
            :loading="isGeneralLoading"
            v-if="(!haveFirmaDelegada && !downloadPDF) && !uploadFirmaDelegada && !isSigned"
            @click.prevent.stop="firmarFirmaDelegada"
            icon="writingsign"
            :text="$t('companies.configuration.firma_delegada.firmar_delegacion_firma')" 
          />
          <base-button-responsive
          v-if="(!haveFirmaDelegada && downloadPDF) || uploadFirmaDelegada"
            mode="secondary"
            :text="uploadFirmaDelegada ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="toggleViewPDF"
            :loading="isGeneralLoading"
          />
          <base-button
            :loading="isGeneralLoading"
            v-if="(!haveFirmaDelegada && downloadPDF) || uploadFirmaDelegada"
            @click.prevent.stop="subirPDFFirmado"
          >
            {{ $t("companies.configuration.firma_delegada.subir_pdf_firma") }}
          </base-button>
        </div>
      </div>
    </template>
  </base-dialog-button>
</template>

<script>
import { i18n } from '@/i18n'
import PDFViewerApp from '@/components/pdf/PDFViewerApp.vue'
import autoscript from '@/scripts/autoscript.js'
import { updateFirmaDelegada } from '@/services/companies/updateFirmaDelegada'
import { Upload } from 'element-ui'
import Loading from 'vue-loading-overlay'

export default {
  name: 'pdf-viewer-dialog',
  components: {
    PDFViewerApp,
    Upload,
    Loading,
  },
  computed: {
    id: function () {
      return parseInt(this.$route.params.id)
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
  },
  mounted () {
    autoscript.cargarAppAfirma()
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false,
    },
    FirmaDelegada: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: i18n.t('companies.configuration.title'),
    },
    blobUrl: {
      type: Blob,
      default: '',
    },
    idCifEmpresa: {
      type: Number,
      default: 0,
    },
    onlyDownload: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'lg',
    },
    uploadFirmaDelegada: {
      type: Boolean,
      default: false,
    },
    isSigned: {
      type: Boolean,
      default: false,
    },

  },
  data () {
    return {
      url: '',
      actualFilterContent: null,
      showPDF: false,
      isOpen: this.dialogOpen,
      pdfData: '',
      cifEmpresa: 0,
      haveFirmaDelegada: true,
      afirma: {
        algorith: 'SHA512withRSA',
        format: 'Adobe PDF',
        params: '',
      },
      form: {},
      file: {
        name: '',
        b64: '',
      },
      downloadPDF: false,
      rules: {},
      uploadRules: {
        file: [
          {
            required: true,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.fileNameMain) {
                callback(new Error(i18n.t('app.fill_data')))
              } else {
                callback()
              }
            }
          },
        ]
      }
    }
  },
  watch: {
    dialogOpen (value, oldValue) {
      this.actualFilterContent = null
      this.showPDF = false
      try {
        if (value && !this.uploadFirmaDelegada) {
          setTimeout(() => {
            this.url = window.URL.createObjectURL(this.blobUrl)
            this.cifEmpresa = this.idCifEmpresa === 0 ? this.id : this.idCifEmpresa
            // this.haveFirmaDelegada = this.FirmaDelegada
            this.haveFirmaDelegada = this.isSigned
          }, 1000)
        } else {
          this.url = ''
        }
      } catch {
        this.doFeedback('Error al descargar al mostrar el PDF')
      } finally {
        setTimeout(() => {
          this.showPDF = true
        }, 200)
      }
    },
  },
  methods: {
    toggleDialog: async function () {
      this.isOpen = !this.isOpen
      this.$emit('toggleDialog')
    },
    toggleViewPDF: function () {
      if (!this.uploadFirmaDelegada) {
        this.downloadPDF = !this.download
      } else {
        this.uploadFirmaDelegada = false
        this.toggleDialog()
      }
    },
    pdfViewerOpenHandler () {
      this.actualFilterContent = null
    },
    descargarArchivo () {
      const link = document.createElement('a')
      link.href = this.url
      if (this.haveFirmaDelegada) {
        link.setAttribute('download', 'Firma-Delegada-Firmada.pdf')
      } else {
        link.setAttribute('download', 'Firma-Delegada.pdf')
      }
      document.body.appendChild(link)
      link.click()

      link.parentNode.removeChild(link)
      window.URL.revokeObjectURL(this.url)
      this.downloadPDF = !this.haveFirmaDelegada && !this.onlyDownload
    },
    handleChange: function (file) {
      this.$refs.uploadpfxref.clearValidate()
      this.file.name = file.name
      this.getBase64(file.raw).then((res) => {
        const b64 = res.split(',')
        this.file.b64 = b64[1]
      })
    },
    handleRemove: function () {
      this.file.name = null
      this.file.b64 = null
    },

    showErrorCallback (errorType, errorMessage) {
      if (errorType === 'es.gob.afirma.standalone.ApplicationNotFoundException') {
        this.doFeedback(i18n.t('companies.configuration.autofirma_not_connected'))
      } else {
        this.doFeedback(errorMessage)
      }
      this.$store.commit('setIsLoading', false)
    },

    showSignResultCallback (signatureB64, certificateB64, extraData) {
      this.pdfData = signatureB64

      if (this.onlyDownload) {
        this.$emit('setFileSigned', this.pdfData)
        this.toggleDialog()
      } else {
        this.enviarPDFFirmado()
      }
      this.download()
      this.$store.commit('setLoading', false)
    },
    subirPDFFirmado () {
      this.$store.commit('setLoading', true)
      this.pdfData = this.file.b64
      this.enviarPDFFirmado()
      this.$store.commit('setLoading', false)
    },
    enviarPDFFirmado: async function () {
      this.$store.commit('setIsLoading', true)
      if (!this.pdfData) {
        this.doFeedback('No se ha detectado ningun PDF')
      }
      console.log(this.cifEmpresa)
      const payload = {
        pdfB64: this.pdfData,
        idCifEmpresa: this.cifEmpresa === 0 ? this.id : this.idCifEmpresa,
      }
      try {
        var response = await updateFirmaDelegada(payload)
        if (response.Respuesta) {
          this.$emit('applyDialog', response.Respuesta)
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.isSigned = true
          this.toggleDialog()
        } else {
          this.isSigned = false
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        }
      } catch (error) {
        this.doFeedback()
        this.isSigned = false
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    doSign () {
      autoscript.sign(
        this.pdfData,
        this.afirma.algorith,
        this.afirma.format,
        this.afirma.params,
        this.showSignResultCallback,
        this.showErrorCallback
      )
    },

    download () {
      var a = document.createElement('a')
      a.href = 'data:application/pdf;base64,' + this.pdfData
      a.download = 'signed.pdf'
      a.click()
    },
    blobToBase64 (blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
    },

    firmarFirmaDelegada: async function () {
      this.$store.commit('setLoading', true)
      this.pdfData = await this.blobToBase64(this.blobUrl)
      this.pdfData = this.pdfData.split(',')[1]
      this.doSign()
    },
  },
}
</script>

<style lang="scss" scoped>
.h-fix-pdf {
  height: calc(60vh - 100px);
}
.main-files-container, .file-attachments-container {
  height: fit-content;
}
</style>
